/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Box } from '@mui/material';
import { Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import CustomPopupText from '../shared/CustomPopupText';
import CustomTextField from '../shared/CustomTextField';
import CustomPicker from '../shared/CustomPicker';
import CustomButtonGroup from '../shared/CustomButtonGroup';
import CustomUploadField from '../shared/CustomUploadField';
import AntSwitch from './AntSwitch';
import SelectInstructorField from './SelectInstructorField';
import AddSource from './AddSource';
import QuillRichTextEditor from '../common/QuillRichTextEditor';
import CustomButton from '../shared/CustomButton';
import Modal from '../common/Modal';
import AssignInstructorDaily from './AssignInstructorDaily';
import CustomFileUploadField from '../shared/CustomFileUploadField';
import useDetails from './hooks/useDetails';
import CustomMultiSelectAll from '../shared/CustomMultiSelectAll';
import { buttons } from './constants';
import { getFormData, getSelectedInstructorDetails, validateForm } from './utils';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { getDoses, getSelectedPubDate, showProgress, getPubDates } from '../../redux/actions/DealershipActions';
import GetPubDates from '../../apis/GetPubDates';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import { DIMENSIONS } from '../../constants/aspectRatio';
import { VideoLinkInput } from '../../features/vimeo-picker';

const useStyle = makeStyles(() => ({
  headerContainer: {
    width: '100%',
    height: '72px',
    padding: '24px 16px',
    background: 'white',
    borderBottom: '1px solid #E4E7EC',
  },
  publishDateField: {
    height: '44px',
    padding: '0px 12px',
    fontSize: '12px',
    margin: '12px 0px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
  },
  contentWrapper: {
    padding: '24px',
    overflowY: 'auto',
    height: 'calc(100% - 72px - 80px)',
  },
  buttonContainer: {
    background: '#FFFFFF',
    padding: '22px',
    borderTop: '1px solid #E4E7EC',
    width: '100%',
  },
}));

const modalStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: '875px',
  backgroundColor: '#F2F4F7',
  borderRadius: '10px',
};

const AddNewStory = ({ isEdit, open, close, add }) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const doseDetails = useSelector((state) => state.getDoseDetails.doseDetails);
  const [data, setData] = useState({});
  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [storyType, setStoryType] = useState('VIDEO');
  const [showInstrList, setShowInstrList] = useState(false);
  const [showAddInstrPopup, setShowAddInstrPopup] = useState(false);
  const [audioFilename, setAudioFilename] = useState(false);
  const [instrImgs, setInstrImgs] = useState(false);
  const [instrNames, setInstrNames] = useState(false);
  const [checkedInstrList, setCheckedInstrList] = useState([]);
  const [showLink, setShowLink] = useState(false);
  const [showExternalLink, setShowExternalLink] = useState(false);
  const [originalAv, setOriginalAv] = useState(null);

  const { instrList: instrlist, plans: planList, getInstructors } = useDetails();

  useEffect(() => {
    if (add && open) {
      getInstructors(storyType);
    }
  }, [add, open, getInstructors, storyType]);

  useEffect(() => {
    if (!add) {
      if (!doseDetails) return;
      getInstructors(doseDetails.type);
      const planId = doseDetails.planIds?.flatMap((id) => planList?.find((plan) => plan.value === id) || []);
      setCheckedInstrList(doseDetails.sources?.map((source) => parseInt(source.id, 10)) || []);
      setData({
        title: doseDetails.title,
        description: doseDetails.description,
        punchLine: doseDetails.punchline,
        duration: doseDetails.readingTime,
        publishDate: doseDetails.publishDate,
        planId,
        externalLinkTitle: doseDetails.externalLinkTitle || '',
        externalLink: doseDetails.externalLink || '',
      });
      setShowExternalLink(!!doseDetails.externalLinkEnabled);
      setStoryType(doseDetails.type);
      setThumbnail(doseDetails.thumbnail);
      const { type, av } = doseDetails;
      if (type === 'VIDEO') {
        const hasAv = av && !_isEmpty(av);
        setOriginalAv(hasAv ? av : null);
        setData((prev) => ({ ...prev, avPreview: hasAv ? av?.url || '' : '' }));
        setShowLink(hasAv);
      } else if (type === 'PODCAST') {
        setData((prev) => ({ ...prev, audioFile: doseDetails.av?.url }));
        setShowLink(!_isEmpty(av));
      } else {
        setData((prev) => ({ ...prev, avPreview: doseDetails.articleLink }));
        setShowLink(!_isEmpty(doseDetails.articleLink));
      }
    } else {
      setCheckedInstrList([]);
      setInstrImgs([]);
      setInstrNames('');
      setOriginalAv(null);
      setShowExternalLink(false);
      setData((prev) => ({ ...prev, link: '' }));
    }
  }, [add, doseDetails, getInstructors, planList]);

  useEffect(() => {
    if (add) return;
    const { images, text, ids } = getSelectedInstructorDetails(
      doseDetails?.sources?.flatMap((source) => parseInt(source?.id, 10)),
      instrlist,
    );
    setInstrImgs(images || []);
    setInstrNames(text || '');
    setCheckedInstrList(ids || []);
  }, [add, doseDetails?.sources, instrlist]);

  const handleAssignInstr = useCallback(() => {
    const { images, text, ids } = getSelectedInstructorDetails(checkedInstrList, instrlist);
    setInstrImgs(images || []);
    setInstrNames(text || '');
    setCheckedInstrList(ids || []);
  }, [checkedInstrList, instrlist]);

  const handleFileChange = (name, files) => {
    if (files.length > 0) {
      const fileData = files[0];
      setAudioFilename(fileData?.name);
      setData((prevData) => ({
        ...prevData,
        [name]: fileData,
      }));
      const reader = new FileReader();
      reader.readAsDataURL(fileData);
    }
  };

  const handleData = ({ target: { name, value, files } }) => {
    if (name === 'audioFile') {
      handleFileChange(name, files);
      return;
    }
    if (name === 'externalLinkTitle' && value.trim().length > 25) return;
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const handlePlanUpdate = (arr) => setData({ ...data, planId: arr });
  const handleDateChange = (label, date) => setData((prev) => ({ ...prev, publishDate: date }));
  const handleThumbnailUpload = (e) => {
    const file = e.target.files[0];
    setThumbnailImg(file);
    const reader = new FileReader();
    reader.onload = (ev) => setThumbnail(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleAssignInstructor = () => setShowInstrList(true);
  const handleCloseInstrList = () => setShowInstrList(false);
  const handleOpenAddSourcePopup = () => setShowAddInstrPopup(true);
  const handleCloseAddSource = () => setShowAddInstrPopup(false);

  const handleTypeChange = useCallback(
    (type) => {
      const typeVal = type === 0 ? 'VIDEO' : type === 1 ? 'ARTICLE' : 'ROCKED_ARTICLE';
      setStoryType(typeVal);
      getInstructors(typeVal);
      setInstrImgs([]);
      setInstrNames('');
    },
    [getInstructors],
  );
  const handleDescriptionChange = (e) => setData((prev) => ({ ...prev, description: e }));

  const handleListItemClick = async (date) => {
    dispatch(getSelectedPubDate(date));
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.STORY_BY_DATE.replace('DATE', date), '')
      .then((response) => {
        dispatch(showProgress(false));
        dispatch(getDoses('add', response));
      })
      .catch(() => {});
  };

  const handleSave = async () => {
    dispatch(showProgress(true));
    if (!validateForm(data, thumbnailImg, storyType, checkedInstrList, !add, thumbnail, showExternalLink)) {
      dispatch(showProgress(false));
      return;
    }
    const formData = getFormData(data, checkedInstrList, storyType, thumbnailImg, originalAv, showExternalLink);
    const apiCall = add
      ? service.post(apiEndpoints.STORY_DOSE, formData)
      : service.put(apiEndpoints.STORY_DOSE_UPDATE.replace('DOSE_ID', doseDetails.id), formData);
    try {
      const response = await apiCall;
      notifySuccess('Completed Successfully');
      const publishDate = response?.publishDate;

      const pubDatesData = await GetPubDates();
      if (pubDatesData) {
        dispatch(getPubDates('add', pubDatesData));
        // Check if the publish date exists in the refreshed dates list
        const dateExists = pubDatesData.some((date) => date.publishDate === publishDate);
        if (dateExists) {
          // Set the selected date after dates are updated (use setTimeout to ensure state is updated)
          setTimeout(() => {
            dispatch(getSelectedPubDate(publishDate));
            handleListItemClick(publishDate);
          }, 100);
        } else {
          // If date doesn't exist in list, still set it
          dispatch(getSelectedPubDate(publishDate));
          handleListItemClick(publishDate);
        }
      } else {
        // If dates refresh fails, still set the selected date
        dispatch(getSelectedPubDate(publishDate));
        handleListItemClick(publishDate);
      }
      close();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  return (
    <Modal isOpen={open} height="80%" width="875px" padding="0px">
      <Box sx={modalStyle}>
        <Grid container justifyContent="space-between" alignItems="center" className={classes.headerContainer}>
          <Grid item>
            <div style={{ fontSize: '20px', fontWeight: 600, color: '#000' }}>{`${add ? 'Add' : 'Edit'} Story`}</div>
          </Grid>
          <Grid item>
            <Close onClick={close} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Grid container direction="column" className={classes.contentWrapper}>
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <CustomPopupText text="Title" required />
                  <CustomTextField defaultValue={data?.title} handleChange={handleData} name="title" width="100%" />
                </Grid>

                <Grid item xs={12}>
                  <CustomPopupText text="Plans" required />
                  <CustomMultiSelectAll
                    placeholderButtonLabel="Select a Dealership Plan"
                    selectedOptions={data?.planId}
                    onChange={handlePlanUpdate}
                    options={planList || []}
                    width="100%"
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomPopupText text="Publish Date" required />
                  <CustomPicker
                    type="default"
                    data={data}
                    handleDateChange={handleDateChange}
                    customStyles={classes.publishDateField}
                    name="publishDate"
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomPopupText text="Select a type" required />
                  <CustomButtonGroup
                    buttons={buttons}
                    handleChange={handleTypeChange}
                    selectedIndex={
                      storyType === 'VIDEO' || storyType === 'PODCAST' ? 0 : storyType === 'ARTICLE' ? 1 : 2
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <VideoLinkInput
                    enabled={showLink}
                    onEnabledChange={setShowLink}
                    value={data?.avPreview || ''}
                    onChange={(val) => handleData({ target: { name: 'avPreview', value: val } })}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomPopupText text="Thumbnail (max size - 100kb)" required />
                  <CustomUploadField
                    type="image"
                    name="story-thumbnail"
                    value={thumbnailImg ? thumbnail : null}
                    imgSrc={!thumbnailImg ? thumbnail : null}
                    handleChange={handleThumbnailUpload}
                    customStyles={{ width: '100%' }}
                    fileName={thumbnailImg?.name}
                    dimensions={DIMENSIONS.story}
                  />
                </Grid>

                {storyType === 'PODCAST' && (
                  <Grid item xs={12}>
                    <CustomPopupText text="Audio File" required />
                    <CustomFileUploadField
                      name="audioFile"
                      handleChange={handleData}
                      fileName={audioFilename}
                      height="44px"
                      width="100%"
                      accepted="audio/*"
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <CustomPopupText text="Select Instructor" required />
                  <SelectInstructorField
                    personText={instrNames}
                    personImage={instrImgs}
                    assignInstructorFn={handleAssignInstructor}
                    openAddSourcePopup={handleOpenAddSourcePopup}
                    classes={classes}
                    setCheckedIntrList={setCheckedInstrList}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <CustomPopupText text="Add an external link?" />
                    </Grid>
                    <Grid item>
                      <AntSwitch
                        checked={showExternalLink}
                        onChange={({ target: { checked } }) => setShowExternalLink(checked)}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {showExternalLink && (
                  <>
                    <Grid item xs={12}>
                      <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                          <CustomPopupText text="Link Title (will be displayed on the app)" required />
                        </Grid>
                        <Grid item>
                          <span style={{ fontSize: '12px', color: '#667085' }}>
                            {`${data?.externalLinkTitle?.trim()?.length || 0}/25`}
                          </span>
                        </Grid>
                      </Grid>
                      <CustomTextField
                        value={data?.externalLinkTitle || ''}
                        handleChange={handleData}
                        name="externalLinkTitle"
                        width="100%"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomPopupText text="External Link" required />
                      <CustomTextField
                        value={data?.externalLink || ''}
                        handleChange={handleData}
                        name="externalLink"
                        placeholder="Add link here"
                        width="100%"
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <CustomPopupText text="PunchLine" required />
                  <CustomTextField
                    defaultValue={data?.punchLine}
                    handleChange={handleData}
                    name="punchLine"
                    width="100%"
                  />
                </Grid>

                <Grid item>
                  <CustomPopupText text="Duration" required />
                  <CustomTextField
                    defaultValue={data?.duration}
                    handleChange={handleData}
                    name="duration"
                    width="100%"
                  />
                </Grid>

                <Grid item>
                  <CustomPopupText text="Description" required />
                  <QuillRichTextEditor value={data?.description} changeFn={handleDescriptionChange} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item className={classes.buttonContainer}>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <CustomButton label="Cancel" type="secondary" onClick={close} />
            </Grid>
            <Grid item>
              <CustomButton label="Save" type="primary" onClick={handleSave} />
            </Grid>
          </Grid>
        </Grid>

        {showAddInstrPopup && (
          <AddSource
            open
            edit={false}
            type="instructor"
            doseType={storyType}
            close={handleCloseAddSource}
            onSuccess={() => getInstructors(storyType)}
          />
        )}
        {showInstrList && (
          <AssignInstructorDaily
            open
            close={handleCloseInstrList}
            add={!isEdit}
            handleAssignInstr={handleAssignInstr}
            instrlist={instrlist}
            doseType={storyType}
            checkedInstrList={checkedInstrList}
            setCheckedInstrList={setCheckedInstrList}
          />
        )}
      </Box>
    </Modal>
  );
};

export default AddNewStory;
